import axios from '../axios';

export const getMetrics = (params = {}) => {
  return axios.get('/dashboard/get_metrics', { params });
};

export const getTodaysJobs = () => {
  return axios.get('/dashboard/get_todays_jobs');
};

export const getAwaitingCompletion = () => {
  return axios.get('/dashboard/get_awaiting_completion');
};

export const getTopServices = (params = {}) => {
  return axios.get('/dashboard/get_top_services', { params });
};

export const getVesselsByClient = (params = {}) => {
  return axios.get('/dashboard/get_vessels_by_client', { params });
};

export const getOperationsMetrics = () => {
  return axios.get('/dashboard/operations_metrics');
};